import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_JOB } from 'src/graphql/job';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationCustomerResourceFileProcessArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation CustomerResourceFileProcess($customerId: ID!, $resourceId: ID!) {
    customerResourceFileProcess(customerId: $customerId, resourceId: $resourceId) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

type Variables = BackendMutationCustomerResourceFileProcessArgs;
type Result = BackendJob;

export const customerResourceFileProcess = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
